// @ts-strict-ignore
import { Injectable, inject } from '@angular/core';
import { ReductionGoalsService } from '../../api/core/services';
import { CreateReductionGoalRequest } from '../../api/core/models/api/create-reduction-goal-request';
import { UpdateReductionGoalRequest } from '../../api/core/models/api/update-reduction-goal-request';
import { ModelService } from '../backend-service/model.service';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BackendReductionGoalsService {
  private _modelService = inject(ModelService);
  private _reductionGoalsService = inject(ReductionGoalsService);

  createReductionGoal({
    boardId,
    reductionGoal: body,
  }: {
    boardId: string;
    reductionGoal: CreateReductionGoalRequest;
  }) {
    return this._reductionGoalsService
      .createReductionGoal({ boardId, body })
      .pipe(map(this._modelService.toBoardReductionGoal));
  }

  deleteReductionGoalById({ boardId, reductionGoalId: id }: { boardId: string; reductionGoalId: string }) {
    return this._reductionGoalsService.deleteReductionGoal({ boardId, id });
  }

  getReductionGoalById({ boardId, reductionGoalId: id }: { boardId: string; reductionGoalId: string }) {
    return this._reductionGoalsService
      .getReductionGoal({ boardId, id })
      .pipe(map(this._modelService.toBoardReductionGoal));
  }

  getReductionGoals({ boardId }: { boardId: string }) {
    return this._reductionGoalsService
      .listReductionGoals({ boardId })
      .pipe(map(({ reductionGoals }) => this._modelService.toBoardReductionGoals(reductionGoals)));
  }

  updateReductionGoalById(params: {
    boardId: string;
    reductionGoalId: string;
    reductionGoal: UpdateReductionGoalRequest;
  }): Observable<string> {
    const { boardId, reductionGoalId: id, reductionGoal: body } = params;
    return this._reductionGoalsService.updateReductionGoal({ boardId, id, body });
  }
}
